import React, { useState, useMemo } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';
import {
  FileText, Users, GraduationCap, BookOpen, UserCheck,
  Download, ExternalLink, FileSignature, Search,
  Copy, CheckCircle2, Filter, X, File,
  FileSpreadsheet, Loader2, ClipboardList, UserX,
  Calendar, AlertCircle, Settings
} from 'lucide-react';

const Students = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [copiedLink, setCopiedLink] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const categories = [
    {
      title: t('studentDocsCategories.category1.title'),
      icon: <BookOpen className="w-5 h-5" />,
      color: 'blue',
      documents: [
        {
          title: t('studentDocsCategories.category1.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/%C3%9C%C3%A7%20Ders%20S%C4%B1nav%C4%B1%20(Akademik%20Ortalama%20Y%C3%BCkseltmek%20%C4%B0%C3%A7in).docx'
        },
        {
          title: t('studentDocsCategories.category1.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/%C3%9C%C3%A7%20Ders%20S%C4%B1nav%C4%B1%20(Ba%C5%9Far%C4%B1s%C4%B1z%20Olunan%20Dersler%20%C4%B0%C3%A7in%20).docx'
        },
        {
          title: t('studentDocsCategories.category1.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Ders%20Muafiyet%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category1.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Ara%20S%C4%B1nav%20Mazeret%20Dilek%C3%A7esi.doc'
        },
        {
          title: t('studentDocsCategories.category1.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/S%C4%B1nav%20Notu%20%C4%B0tiraz%20Dilek%C3%A7esi.docx'
        }
      ]
    },
    {
      title: t('studentDocsCategories.category2.title'),
      icon: <Settings className="w-5 h-5" />,
      color: 'green',
      documents: [
        {
          title: t('studentDocsCategories.category2.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Se%C3%A7meli%20Ders%20Sildirme%20Dilek%C3%A7esi.doc'
        },
        {
          title: t('studentDocsCategories.category2.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Se%C3%A7meli%20Ders%20Yerine%20Se%C3%A7meli%20Ders%20Alma%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category2.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/%C3%96%C4%9Frenci/yararl%C4%B1%20belgeler/Ekle%20Silden%20Sonraki%207%20G%C3%BCn%20%C4%B0%C3%A7inde%20Ders-Ekleme-Silme%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category2.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Ders%20%C5%9Eube%20De%C4%9Fi%C5%9Fikli%C4%9Fi%20Ba%C5%9Fvuru%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category2.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Di%C4%9Fer%20%C3%9Cniversitelerden%20E%C5%9Fde%C4%9Fer%20Ders%20Alma%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category2.doc6'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Son%20%C4%B0ki%20Yari%C4%B1yil%20%C4%B0%C3%A7inde%20Acilmayan%20Ba%C5%9Far%C4%B1s%C4%B1z%20Olunan%20Secmeli%20Dersi%20Sildirme%20Dilekcesi.docx'
        },
        {
          title: t('studentDocsCategories.category2.doc7'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Savunma%20Sanayii%20Ders%20Saydirma%20Dilekcesi.docx'
        },
        {
          title: t('studentDocsCategories.category2.doc8'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Yaz%20Okulu%20Ders%20Alma%20Dilek%C3%A7esi.docx'
        }
      ]
    },
    {
      title: t('studentDocsCategories.category3.title'),
      icon: <GraduationCap className="w-5 h-5" />,
      color: 'purple',
      documents: [
        {
          title: t('studentDocsCategories.category3.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Yandal%20Program%C4%B1%20Ba%C5%9Fvuru%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category3.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/%C3%87ift%20Anadal%20Program%C4%B1%20Ba%C5%9Fvuru%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category3.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/%C3%96zel%20%C3%96%C4%9Frenci%20Ders%20Alma%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category3.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Erasmus%20Giden%20%C3%96%C4%9Frenci%20Esdegerlik%20Formu.doc'
        },
        {
          title: t('studentDocsCategories.category3.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Erasmus%20Izinli%20Say%C4%B1lma%20Dilekcesi%20(Koordinat%C3%B6r).docx'
        },
        {
          title: t('studentDocsCategories.category3.doc6'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Erasmus%20%C3%96%C4%9Frenim%20D%C3%B6n%C3%BC%C5%9F%20Ders%20E%C5%9Fde%C4%9Ferli%C4%9Fi%20%C4%B0%C5%9Fletme%20Dilek%C3%A7esi%20(%C3%96%C4%9Frenci).docx'
        }
      ]
    },
    {
      title: t('studentDocsCategories.category4.title'),
      icon: <UserCheck className="w-5 h-5" />,
      color: 'indigo',
      documents: [
        {
          title: t('studentDocsCategories.category4.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/%C4%B0zinli%20Say%C4%B1lma%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category4.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/%C3%96%C4%9Frenci%20%C4%B0li%C5%9Fik%20Kesme%20Formu.pdf'
        },
        {
          title: t('studentDocsCategories.category4.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Azami%20S%C3%BCresini%20Dolduran%20%C3%96%C4%9Frencilerin%20%C4%B0%C3%A7in%203%20Yar%C4%B1yil%20Ek%20S%C3%BCre%20Talep%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category4.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Azami%20S%C3%BCresini%20Dolduran%20%C3%96%C4%9Frencilerin%20%C4%B0%C3%A7in%204%20Yar%C4%B1yil%20Ek%20S%C3%BCre%20Talep%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category4.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Azami%20S%C3%BCresini%20Dolduran%20%C3%96%C4%9Frencilerin%20%C4%B0%C3%A7in%20Tek%20Dersi%20Kalanlara%20S%C4%B1n%C4%B1rs%C4%B1z%20S%C4%B1nav%20Hakk%C4%B1%20Talep%20Formu.docx'
        },
        {
          title: t('studentDocsCategories.category4.doc6'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Azami%20S%C3%BCresini%20Dolduran%20%C3%96%C4%9Frencilerin%20Programlar%C4%B1na%20Hi%C3%A7%20Almad%C4%B1klar%C4%B1%20Dersler%20%C4%B0%C3%A7in%20%C4%B0ki%20Ek%20S%C4%B1nav%20Hakk%C4%B1%20Talep%20Dilek%C3%A7esi.docx'
        },
        {
          title: t('studentDocsCategories.category4.doc7'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/yararlibelgeler/Azami%20S%C3%BCresini%20Dolduran%20%C3%96%C4%9Frencilerin%20Uygulama%20Dersleri%20%C4%B0%C3%A7in%201%20Yar%C4%B1yil%20Ek%20S%C3%BCre%20Talep%20Dilek%C3%A7esi.docx'
        }
      ]
    },
    {
      title: t('studentDocsCategories.category5.title'),
      icon: <ClipboardList className="w-5 h-5" />,
      color: 'rose',
      documents: [
        {
          title: t('studentDocsCategories.category5.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%B6%C4%9Frenci/staj-is-akisi.pdf.pdf'
        },
        {
          title: t('studentDocsCategories.category5.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%B6%C4%9Frenci/ek-1-stajyer-ogrencilerin-sigorta-islemleri-icin-izlenecek-yol.pdf.pdf'
        },
        {
          title: t('studentDocsCategories.category5.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%B6%C4%9Frenci/ek-2-stajyer-ogrenci-bilgileri-formu.xlsx.xlsx'
        },
        {
          title: t('studentDocsCategories.category5.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%B6%C4%9Frenci/ek-3-isyerine-basvuru-ve-kabul-formu.docx.docx'
        },
        {
          title: t('studentDocsCategories.category5.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%B6%C4%9Frenci/ek-4-beyan-ve-taahhutname-saglik-hizmeti-alan.docx.docx'
        },
        {
          title: t('studentDocsCategories.category5.doc6'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%B6%C4%9Frenci/ek-5-beyan-ve-taahhutname-saglik-hizmeti-almayan.docx.docx'
        }
      ]
    }
  ];

  const allCategories = categories;

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-gradient-to-r from-blue-600 to-blue-700 text-white',
      green: 'bg-gradient-to-r from-green-600 to-green-700 text-white',
      purple: 'bg-gradient-to-r from-purple-600 to-purple-700 text-white',
      indigo: 'bg-gradient-to-r from-indigo-600 to-indigo-700 text-white',
      rose: 'bg-gradient-to-r from-rose-600 to-rose-700 text-white',
      amber: 'bg-gradient-to-r from-amber-600 to-amber-700 text-white',
      cyan: 'bg-gradient-to-r from-cyan-600 to-cyan-700 text-white',
      emerald: 'bg-gradient-to-r from-emerald-600 to-emerald-700 text-white',
      slate: 'bg-gradient-to-r from-slate-600 to-slate-700 text-white'
    };
    return colorMap[color] || colorMap.blue;
  };

  const getFileIcon = (link) => {
    if (link.endsWith('.pdf')) return <FileText className="w-5 h-5 text-red-500" />;
    if (link.endsWith('.doc') || link.endsWith('.docx')) return <FileText className="w-5 h-5 text-blue-500" />;
    if (link.endsWith('.xls') || link.endsWith('.xlsx')) return <FileSpreadsheet className="w-5 h-5 text-green-500" />;
    return <File className="w-5 h-5 text-gray-500" />;
  };

  const getFileType = (link) => {
    if (link.endsWith('.pdf')) return 'PDF';
    if (link.endsWith('.doc') || link.endsWith('.docx')) return 'WORD';
    if (link.endsWith('.xls') || link.endsWith('.xlsx')) return 'EXCEL';
    return 'BELGE';
  };

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link);
    setCopiedLink(link);
    setTimeout(() => setCopiedLink(null), 2000);
  };

  const handleSearch = (value) => {
    setIsLoading(true);
    setSearchTerm(value);
    // Simulate loading state
    setTimeout(() => setIsLoading(false), 500);
  };

  const filteredCategories = useMemo(() => {
    const filtered = allCategories
      .map(category => ({
        ...category,
        documents: category.documents.filter(doc =>
          doc.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
      }))
      .filter(category => category.documents.length > 0);

    if (selectedCategory === 'all') return filtered;
    return filtered.filter(category => category.title === selectedCategory);
  }, [searchTerm, selectedCategory, allCategories]);

  const uniqueCategories = useMemo(() => 
    ['all', ...new Set(allCategories.map(cat => cat.title))],
    [allCategories]
  );

  const totalDocuments = useMemo(() => 
    filteredCategories.reduce((sum, cat) => sum + cat.documents.length, 0),
    [filteredCategories]
  );

  const DocumentCard = ({ document }) => {
    const fileIcon = getFileIcon(document.link);
    const fileType = getFileType(document.link);
    
    return (
      <div className="group relative">
        <a
          href={document.link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center p-4 hover:bg-gray-50 rounded-lg transition-all duration-200 border-l-4 border-l-transparent hover:border-l-blue-400 hover:shadow-sm cursor-pointer"
        >
          <div className="flex-shrink-0 mr-4">
            {fileIcon}
          </div>
          <div className="flex-grow min-w-0">
            <div className="flex items-start gap-3">
              <span className="text-base text-gray-700 group-hover:text-blue-600 leading-relaxed transition-colors">
                {document.title}
              </span>
              <span className="flex-shrink-0 px-2.5 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded-full group-hover:bg-blue-100 group-hover:text-blue-700 transition-colors">
                {fileType}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-2 ml-4">
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleCopyLink(document.link);
              }}
              className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-lg transition-colors group/button z-10 relative"
              title={t('studentDocuments.copyLink')}
            >
              {copiedLink === document.link ? (
                <CheckCircle2 className="w-5 h-5 text-green-500" />
              ) : (
                <Copy className="w-5 h-5 group-hover/button:scale-110 transition-transform" />
              )}
            </button>
            <div className="p-2 text-gray-400 group-hover:text-blue-500 transition-colors">
              <ExternalLink className="w-5 h-5 group-hover:scale-110 transition-transform" />
            </div>
          </div>
        </a>
      </div>
    );
  };

  return (
    <PageTemplate
      title={t('pages.documents.title')}
      subtitle={t('pages.documents.subtitle')}
    >
      <div className="max-w-[1400px] mx-auto px-4 py-8">
        {/* Başlık ve Açıklama */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl mb-6">
            <Users className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('studentDocuments.title')}</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('studentDocuments.description')}
          </p>
        </div>

        <div className="mb-8">
          {/* Arama ve Filtreleme */}
          <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center mb-8">
            <div className="relative flex-grow">
              <input
                type="text"
                placeholder={t('studentDocuments.searchPlaceholder')}
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                className="w-full px-6 py-4 pl-14 text-lg rounded-2xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 shadow-sm"
              />
              <div className="absolute left-5 top-1/2 transform -translate-y-1/2">
                {isLoading ? (
                  <Loader2 className="w-6 h-6 text-gray-400 animate-spin" />
                ) : (
                  <Search className="w-6 h-6 text-gray-400" />
                )}
              </div>
              {searchTerm && (
                <button
                  onClick={() => handleSearch('')}
                  className="absolute right-5 top-1/2 transform -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="w-5 h-5 text-gray-400" />
                </button>
              )}
            </div>
            
            <div className="relative group lg:min-w-[250px]">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full px-6 py-4 pr-12 text-base rounded-2xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 appearance-none bg-white shadow-sm"
              >
                <option value="all">{t('studentDocuments.allCategories')}</option>
                {uniqueCategories.slice(1).map((cat, idx) => (
                  <option key={idx} value={cat}>{cat}</option>
                ))}
              </select>
              <Filter className="w-5 h-5 text-gray-400 absolute right-5 top-1/2 transform -translate-y-1/2 pointer-events-none" />
            </div>
          </div>

          {/* Sonuç Özeti */}
          <div className="flex items-center justify-between text-sm text-gray-500 bg-gray-50 rounded-xl p-4">
            <div className="flex items-center gap-2">
              <AlertCircle className="w-4 h-4" />
              <span>
                <strong>{totalDocuments}</strong> {t('studentDocuments.documentsFound')}
                {searchTerm && ` "${searchTerm}" ${t('common.for')}`}
                {selectedCategory !== 'all' && ` ${selectedCategory} ${t('common.inCategory')}`}
              </span>
            </div>
            {(searchTerm || selectedCategory !== 'all') && (
              <button
                onClick={() => {
                  setSearchTerm('');
                  setSelectedCategory('all');
                }}
                className="text-blue-500 hover:text-blue-600 font-medium transition-colors"
              >
                {t('studentDocuments.clearFilters')}
              </button>
            )}
          </div>
        </div>

        {/* Kategoriler Grid */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
          {filteredCategories.map((category, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className={`px-8 py-6 flex items-center justify-between ${getColorClasses(category.color)}`}>
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-white/15 rounded-xl backdrop-blur-sm">
                    {React.cloneElement(category.icon, { className: "w-6 h-6" })}
                  </div>
                  <div>
                    <h3 className="font-bold text-lg tracking-tight">{category.title}</h3>
                    <p className="text-white/80 text-sm mt-1">
                      {t('studentDocuments.documentsForStudies')}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <span className="px-3 py-1.5 bg-white/20 rounded-full text-sm font-medium backdrop-blur-sm">
                    {category.documents.length}
                  </span>
                  <p className="text-white/80 text-xs mt-1">{t('studentDocuments.document')}</p>
                </div>
              </div>
              <div className="divide-y divide-gray-100">
                {category.documents.map((doc, docIndex) => (
                  <DocumentCard key={docIndex} document={doc} />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Boş Sonuç */}
        {filteredCategories.length === 0 && (
          <div className="text-center py-20 bg-white rounded-2xl shadow-lg border border-gray-100">
            <div className="text-gray-400 mb-6">
              <Search className="w-20 h-20 mx-auto" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">{t('studentDocuments.noResults')}</h3>
            <p className="text-gray-600 text-lg mb-6">
              {t('studentDocuments.noResultsDesc')}
            </p>
            <button
              onClick={() => {
                setSearchTerm('');
                setSelectedCategory('all');
              }}
              className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors font-medium"
            >
              {t('studentDocuments.showAll')}
            </button>
          </div>
        )}

        {/* Bilgilendirme */}
        <div className="mt-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <AlertCircle className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">{t('studentDocuments.importantInfo')}</h4>
              <p className="text-gray-700 leading-relaxed">
                {t('studentDocuments.infoText')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Students; 